import React from 'react';
import PropTypes from 'prop-types';
import Theme from '../themes';
import Icon from '../components/shared/Icons/Icon';

class Logo extends React.PureComponent {
  render() {
    const { type, width } = this.props;
    const logoRatio = 2.719;
    const logoHeight = width / logoRatio;
    const isologoSize = (width / logoRatio) * 0.85;

    return (
      <div className="logo">
        <span className="isologo">
          <Icon type={type} fill={Theme[type].main} width={isologoSize} height={isologoSize} />
        </span>
        <Icon type="logo" fill={Theme.global.logo} width={width} height={logoHeight} />
        <style jsx>
          {`
            .isologo :global(svg) {
              margin-right: 3px;
              vertical-align: bottom;
            }

            :global(.rtl) .isologo :global(svg) {
              margin-left: 3px;
              margin-right: 0;
            }
          `}
        </style>
      </div>
    );
  }
}

Logo.defaultProps = {
  width: '1em',
};

Logo.propTypes = {
  type: PropTypes.string.isRequired,
  width: PropTypes.any,
};

export default Logo;



// WEBPACK FOOTER //
// ./app/common/Logo.js